import { SHORT_SCREEN_HEIGHT } from '../../utils/constants'

const useStyles = {
  imageContainer: {
    width: '100%',
    textAlign: 'center',
    marginBottom: '16px',
    marginTop: '100px',
    [`@media (max-height:${SHORT_SCREEN_HEIGHT})`]: {
      marginTop: '40px',
    },
  },
  useCaseIcon: {
    fontSize: '30px',
  },
  slimOuterContainer: {
    flexDirection: 'column',
    marginTop: 8,
    marginX: { xs: 2, sm: 1 },
  },
  slimFeaturesContainer: {
    flexDirection: 'column',
    gap: 0.5,
  },
  slimMeetYourText: {
    fontWeight: '300',
  },
  slimSensorNameText: {
    fontWeight: '600',
  },
  lfImageContainer: {
    width: '100%',
    textAlign: 'center',
    marginY: '16px',
  },
  lfTitleContainer: {
    flexDirection: 'column',
    marginX: { xs: 2, sm: 1 },
    marginBottom: 4,
    gap: 0.5,
  },
  lfSubtitleContainer: {
    flexDirection: 'column',
    marginX: { xs: 2, sm: 1 },
  },
  lfHeading: {
    fontWeight: '300',
  },
  lfTitle: {
    fontWeight: '600',
  },
}

export default useStyles
